export enum ActionContainerVariant {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
}
